import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Mobile from "./Mobile";
import VisitorSignIn from "./VisitorSignIn";
import SignInSuccess from "./SignInSuccess";
import NdaSign from "./NdaSign";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/mobile" element={<Mobile />} />
                <Route path="/sign-in" element={<VisitorSignIn />} />
                <Route path="/sign-nda" element={<NdaSign />} />
                <Route path="/success" element={<SignInSuccess />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
